export default class StickyFooterMenu {
    constructor($el) {
        this.$el = $el;
        this.$wrapper = document.querySelector('[data-wrapper]');

        this.$wrapper.style.setProperty('--sticky-footer-height', `${this.$el.scrollHeight}px`);
    }
}